module.exports = __webpack_public_path__ + "assets/img/11bp_316.08b88e65.jpg";